import React from 'react';
import './HomePage.css';

const homeContent = [
    {
        image: "https://www.cambridge.org/files/6615/7106/4611/Topazblue1.jpg",
        title: "Welcome to Muthetheni Aic",
        message: "Muthetheni AIC is a christian church located as machakos county"
    },
    {
        image: "https://i.pinimg.com/originals/49/39/38/49393895b8b4006ccc12962f1286696f.jpg",
        title: "Board of mission",
        message: "The Anglican Church of Kenya has launched her first Thematic Focus for the year according to her 10 Year decade strategy"
    },
    {
        image: "https://thumbs.dreamstime.com/b/open-bible-black-background-70567202.jpg",
        title: "News Blog",
        message: "The Anglican Church of Kenya has launched her first Thematic Focus for the year according to her 10 Year decade strategy"
    },
    {
        image: "https://ca-times.brightspotcdn.com/dims4/default/9211a79/2147483647/strip/true/crop/2048x1360+0+0/resize/1486x987!/quality/90/?url=https%3A%2F%2Fwww.trbimg.com%2Fimg-5d56bee3%2Fturbine%2Fsns-201907300011--tms--bgrahamctnym-a20190816-a-20190816",
        title: "Board of social services",
        message: "By giving the church a touch of the world and the world a touch of the church, this board seeks to address the major areas of societal concern-Development, Communication, Justice, Peace and reconciliation as well as Researching the roots of societal evils and coming up with positive solutions."
    }
]


function HomePage() {

    return (
        <div className="homePage">
            <div className="homePage__content">
                {homeContent.map((item, index) => (
                    <div key={index} className="contentBody-1">
                        <img src={item.image} alt={item.title}/>
                        <h3>{item.title}</h3>
                        <p>{item.message}</p>
                     </div>
                ))}

            </div>
        </div>
    )
}

export default HomePage
